<template>
  <div v-if="modelValue" class="cn-header-mobile-search">
    <div class="container">
      <div class="cn-header-mobile-search__wrapper">
        <div class="cn-header-mobile-search__top">
          <button
            class="cn-header-mobile-search__close-button flex items-center"
            @click="close"
          >
            <UiIcon name="chevron-left" />
            <span>{{ $t('back') }}</span>
          </button>
        </div>
        <div class="cn-header-mobile-search__bottom">
          <AppSearch dark @search="search" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppSearch from '@/components/AppSearch';
import UiIcon from '@/components/ui/UiIcon';

interface Props {
  modelValue?: boolean;
}

defineProps<Props>();
const emit = defineEmits<{
  (e: 'update:modelValue', data: boolean): void;
  (e: 'search'): void;
}>();

const close = () => {
  emit('update:modelValue', false);
};
const search = () => {
  close();
  emit('search');
};
</script>

<style lang="scss">
.cn-header-mobile-search {
  --ab-canyon-header-mobile-search-color-bg: var(--ab-canyon-color-primary);
  --ab-canyon-header-mobile-search-close-button-color-text: var(
    --ab-canyon-color-neutral
  );

  background-color: var(--ab-canyon-header-mobile-search-color-bg);
  height: 100vh;
  z-index: 40;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  position: fixed;
  &__top {
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
  }
  &__bottom {
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
  }
  &__close-button {
    color: var(--ab-canyon-header-mobile-search-close-button-color-text);
    .cn-icon {
      width: var(--size-lg);
      height: var(--size-lg);
      margin-right: calc(var(--size-base) / 4);
    }
  }
}
</style>
